<template>
  <div>
    <router-view/>
    <notify></notify>
  </div>
</template>

<script>
import notify from './components/common/notify'
export default {
  name: 'App',
  components: {
    notify
  }
}
</script>

<style scoped lang="scss">
  @font-face {
    font-family: 'BPGNinoMtavruli';
    src: url('./assets/fonts/bpgninomtavrulinormal.eot');
    src: url('./assets/fonts/bpgninomtavrulinormal.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/bpgninomtavrulinormal.woff2') format('woff2'),
    url('./assets/fonts/bpgninomtavrulinormal.woff') format('woff'),
    url('./assets/fonts/bpgninomtavrulinormal.ttf') format('truetype'),
    url('./assets/fonts/bpgninomtavrulinormal.svg') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  * {
    font-family: 'BPGNinoMtavruli';
  }
</style>



// WEBPACK FOOTER //
// src/App.vue